<template>
  <div>
    <!-- TODO: refactor markup Header Component-->
    <b-navbar  type="light" fixed="top" toggleable="lg" class="navbar-default py-0">
      <b-container>
        <b-navbar-brand href="#">
          <img src="@/assets/images/logos/logoMarioViajes.png" alt="logo"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <mainMenu></mainMenu>
          <b-navbar-nav class="mx-auto mt-3 mt-sm-0 d-none d-sm-block" id="main-dropdown">
            <b-dropdown variant="light" class="m-2 mv-navbar-toggle-btn">
              <template v-slot:button-content>
                <span class="mv-dropdown-btn-text">{{ userData.fname }} {{ userData.lname }} / {{ userData.name}}</span>
              </template>
              <secondaryMenu></secondaryMenu>
            </b-dropdown>
          </b-navbar-nav>
          <b-navbar-nav  class="d-sm-none">
            <span class="nav-link">
              <b-icon icon="person-circle" class="mr-2"></b-icon>
              {{ userData.fname }} {{ userData.lname }} / {{ userData.name}}</span>
            <secondaryMenu></secondaryMenu>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

  </div>
</template>

<script>
import mainMenu from './main_menu'
import secondaryMenu from './secondary_menu'
import authMixin from 'b2b-common/mixins/auth'

export default {
  name: 'privateHeader',
  components: { mainMenu, secondaryMenu },
  mixins: [authMixin]
}
</script>
